import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=4d3945be&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Key.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Key.vue
// module id = 2314
// module chunks = 1